import { Box } from '@mui/material';

const OFFSETS = [0, 55, -40, 80, -70, 30, 95, -25, 65, -85, 15, 50];
const R = 38;

const WreathSpinner = ({ size = 100 }: { size?: number }) => (
	<Box sx={{ width: '100%', height: '100%', m: 'auto', display: 'flex' }}>
		<Box
			component="svg"
			role="status"
			aria-label="Loading"
			viewBox="0 0 100 100"
			sx={{
				width: size,
				height: size,
				m: 'auto',
				display: 'block',
				'@keyframes wreath-spin': { from: { transform: 'rotate(0deg)' }, to: { transform: 'rotate(360deg)' } },
				animation: 'wreath-spin 2.4s linear infinite',
				transformBox: 'fill-box',
				transformOrigin: 'center'
			}}
		>
			{Array.from({ length: 24 }, (_, i) => {
				const a = (360 / 24) * i;
				const rad = (a * Math.PI) / 180;
				const cx = 50 + R * Math.sin(rad);
				const cy = 50 - R * Math.cos(rad);
				return (
					<ellipse
						key={i}
						cx={cx} cy={cy} rx="3.2" ry="6.5"
						fill={i % 3 === 0 ? '#6aaa50' : i % 3 === 1 ? '#8dc870' : '#a8e090'}
						transform={`rotate(${a + OFFSETS[i % OFFSETS.length]} ${cx} ${cy})`}
					/>
				);
			})}
			{[0, 60, 120, 180, 240, 300].map((a) => {
				const rad = (a * Math.PI) / 180;
				const cx = 50 + R * Math.sin(rad);
				const cy = 50 - R * Math.cos(rad);
				return (
					<g key={a}>
						{[0, 45, 90, 135, 180, 225, 270, 315].map((p) => (
							<ellipse key={p} cx={cx} cy={cy - 4.5} rx="1.8" ry="4.5" fill="#f9c8dc" transform={`rotate(${a + p} ${cx} ${cy})`} />
						))}
						<circle cx={cx} cy={cy} r="2.4" fill="#f5d060" />
						<circle cx={cx} cy={cy} r="1.2" fill="#e8a030" />
					</g>
				);
			})}
		</Box>
	</Box>
);

export default WreathSpinner;
